/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Grid, Typography, Badge, Box, colors, LinearProgress } from '@mui/material';
import FxCard from '../../../Container/FxCard';
import FxCardBody from '../../../Container/FxCardBody';
import { ReactComponent as Verified } from '../../../../assets/svg/verify-filled-icon.svg';
import { ReactComponent as NotVerified } from '../../../../assets/svg/red-x-line-icon.svg';
import { useMediaQuery } from 'react-responsive';
import FxCardFooter from '../../../Container/FxCardFooter';
import { ReactComponent as ShieldSignupLeftpanel } from '../../../../assets/svg/signup/shield-signup-leftpanel.svg';
import { getKey } from '../../../../libs/utils/storageManager';
import { FieldErrorMessageRender } from '../Common/FieldErrorMessageRender';
import { checkMenuValid } from '../Common/CommonSignupClass';
import { FxStepper, IStep } from '../../../Input/FxStepper/FxStepper';
import { ReactComponent as Warning } from '../../../../assets/svg/pending.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/svg/stepper-arrow.svg'
import { useIsMobileOrTabletScreen } from '../../../../libs/utils/utils';
import { SuccessIconWithClass } from '../Common/SuccessIconWithClass';
/**
 * Component: BusinessLeftBarSignup
 */ 
export const BusinessLeftBarSignup: React.FC<any> = React.memo((props) => {
  const isMobileScreen = useIsMobileOrTabletScreen();
  let keys = ['businessDetailsSignupForm','businessOwnerCardForm']
  // declaring the menu options
  const options: any = [
    {
      title: "Enter Your Company Information",
      subtitle:"We'll verify your details to ensure a secure and compliant experience.",
      action: "business_details",
      order: 1,
      valid:props?.validateForm?.["businessDetailsSignupForm"] ?? true
    },
    {
      title: "Provide Ownership Information",
      subtitle:"Federal law requires us to verify key owners and a control person",
      action: "beneficial_owner",
      order: 2,
      valid:props?.validateForm?.["businessOwnerCardForm"] ?? true
    }
  ];
  options.push({
    title: "Review & Submit for Verification",
    subtitle:"Double-check your details and submit to complete your account setup",
    action: "review_and_submit",
    order: 3,
    valid:true
  })
   const activationSteps: IStep[] = [
         {
             'icon': SuccessIconWithClass,
             'text': 'Company Information'
         },
         {
           icon: () => <ArrowIcon />
         },
         { 
             'icon': (props.activeMainMenu === 2|| props.activeMainMenu === 3 ) ? SuccessIconWithClass : Warning,
             'text': 'Ownership Information'
         },
         {
          icon: () => <ArrowIcon />
        },
        { 
            'icon': props.activeMainMenu === 3 ? SuccessIconWithClass : Warning,
            'text': 'Review & Submit'
        }
  ]
    const progress = (props.activeMainMenu===3) ? 60 : (props.activeMainMenu===2) ? 56 : (props.activeMainMenu===1) ? 33 : 0;

  const errors ={
    'businessDetailsSignupForm':{
      type:"complete",
    },
    'businessOwnerCardForm':{
      type:"complete",
    },
  }

  //Method handles the sub menu click
  const handleChildTitleClick = (mainOrder: any, subOrder: any) => {
    if (props.onClick && props.data['businessDetailsData']) {
      props.onClick(mainOrder, subOrder)
    }
  }

  const handleMenuClick = (action: string) => {
    if (props.goBackClick) {
      if(action==='business_details'){
        props.goBackClick(1);
      }else if(action==='beneficial_owner'){
        props.goBackClick(2);
      }else if(action==='review_and_submit'){
        props.goBackClick(3);
      }
    }
  };
  return (
    <>
    {
     !isMobileScreen ?
      <Grid id="login-promo-Home-Grid" container  item xs={12} >
      <FxCard id="login-promo-Home-Card" className="fx-login-promo fx-login-promo-width-and-bg">
        <Grid container direction="row" justifyContent="space-between" >
                <Grid item xs={10}>
                  <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
                    Welcome!
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
                    Let's set up your Passport Account
                  </Typography>
                </Grid>
              </Grid>
        <FxCardBody id="login-promo-Home-Card-Body">
          <Grid item container xs={12} className='fx-signup-stage'>
           

            {options.map((link: any, index: any) => {
              return (
                <>
                  {link.title === 'Review & Submit for Verification' && <Grid item xs={12}>
                  </Grid>}
                  <Grid item xs={12}><ul id={'login-promo-icon-' + link.action}  >
                    <li className={props.activeMainMenu === link.order ? 'fx-signup-stage-selected-theme-color' : ''}>
                      <Grid item container xs={12}>
                        <Grid item>
                          <Badge badgeContent={index + 1}  >
                            <Box className='fx-signup-stage-icon'>
                              {checkMenuValid(link, keys[index], props.activeMainMenu)}
                            </Box>
                          </Badge>
                        </Grid>
                        <Grid item xs>
                          <Typography
                            variant="h4"
                            className="fx-list-item-maintitle"
                            onClick={() => handleMenuClick(link.action)}
                          >
                            {link.title}
                          </Typography>
                          {link.subtitle && (
                            <Typography variant="body2" className="fx-list-item-subtitle">
                              {link.subtitle}
                            </Typography>
                          )}
                          
                              {(!link.valid && getKey(keys[index]) !== 'valid') && 
                              <FieldErrorMessageRender  error={errors} fieldKey={keys[index]} />}
                        </Grid>
                      </Grid>
                      <ul>
                        {link.childOptions?.map((childLink: any) => {
                          return <li>
                            <Typography variant="h6" onClick={() => handleChildTitleClick(link.order, childLink.order)} className={props.activeMainMenu === link.order && props.activeSubMenu === childLink.order ? 'fx-selected-list' : ''}>{childLink.title}
                            </Typography></li>
                        })}
                      </ul>
                    </li>
                  </ul></Grid>
                </>
              )
            })}
          </Grid>
        </FxCardBody>
        <FxCardFooter>
          <Grid xs={12} columnSpacing={2}>
            <div className="left-panel-privacy left-panel-privacy-business">
              <ShieldSignupLeftpanel />
              <p>Your privacy matters to us. Your information is securely stored and encrypted.</p>
            </div>
          </Grid>
        </FxCardFooter>
      </FxCard>
      </Grid>
      :
          <Grid container item xs={12} sm={12} md={12} className='fx-stepper fx-kyc-stepper fx-stepper-mob' >
            <FxStepper steps={activationSteps} alternativeLabel={true} />
          </Grid>
    }
    </>
    
  )
})
